// Fonction pour convertir les URLs Google Drive en URLs publiques
export const getPublicImageUrl = (url) => {
  if (!url) return '';
  
  console.log('URL originale:', url);
  
  // Si c'est déjà une URL publique, la retourner telle quelle
  if (url.includes('http') && !url.includes('drive.google.com')) {
    console.log('URL déjà publique:', url);
    return url;
  }
  
  // Si c'est une URL Google Drive, la convertir
  if (url.includes('drive.google.com')) {
    // Format: https://drive.google.com/file/d/FILE_ID/view
    const match = url.match(/\/file\/d\/([a-zA-Z0-9-_]+)/);
    if (match) {
      const convertedUrl = `https://drive.google.com/uc?export=view&id=${match[1]}`;
      console.log('URL Google Drive convertie:', convertedUrl);
      return convertedUrl;
    }
    
    // Format alternatif: https://drive.google.com/open?id=FILE_ID
    const openMatch = url.match(/[?&]id=([a-zA-Z0-9-_]+)/);
    if (openMatch) {
      const convertedUrl = `https://drive.google.com/uc?export=view&id=${openMatch[1]}`;
      console.log('URL Google Drive (format open) convertie:', convertedUrl);
      return convertedUrl;
    }
  }
  
  console.log('URL non reconnue, retournée telle quelle:', url);
  return url;
};

// Fonction pour tester si une URL d'image est accessible
export const testImageUrl = async (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = getPublicImageUrl(url);
  });
};

// Image de fallback en base64
export const FALLBACK_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RnG4W+FgYxN';
